import { ButtonLink } from "@/components/Buttons/index";
import routes from "@/lib/routes";
import { useMemo } from "react";

export default function PurchaseButtonLink({ product, ...props }) {
  const [text, color] = useMemo(() => {
    if (product.purchaseAllowed) {
      return ["購入する", { fillColor: true }];
    } else {
      return ["販売期間外", { fillGray: true }];
    }
  }, [product]);
  return (
    <ButtonLink
      href={routes.tvodPaymentStep(product.id, 1)}
      fontFixed
      disabled={!product.purchaseAllowed}
      {...color}
      {...props}
    >
      {text}
    </ButtonLink>
  );
}
